import React from 'react';
import { DateSelect, FormField } from '.';

const DateFormField = ({
  onChange,
  value,
  disabled,
  dateProps,
  ...props
}) => (
    <FormField {...{ ...props, type: null }}>
      <DateSelect disabled={disabled} date={value} onChange={onChange} {...dateProps} />
    </FormField>
  );

export default DateFormField;



// WEBPACK FOOTER //
// ./src/containers/components/date-form-field.js